import { RibbonGroupBase } from '../ribbon-interfaces';
// Clipboard group constants
export const CLIPBOARD_GROUP_ID = '_clipboard_group';
export const CUT_ID = '_cut';
export const COPY_ID = '_copy';
export const PASTE_ID = '_paste';
export const LOCAL_CLIPBOARD_ID = '_local_clipboard';
/**
 * ClipboardGroup class for handling clipboard operations in Document Editor ribbon
 * @private
 */
export class ClipboardGroup extends RibbonGroupBase {
    /**
     * Get the Ribbon group model for Clipboard
     * @returns {RibbonGroupModel} - The ribbon group model for Clipboard
     * @private
     */
    getGroupModel() {
        const id = this.ribbonId;
        return {
            id: id + CLIPBOARD_GROUP_ID,
            cssClass: 'e-clipboard-group',
            header: this.localObj.getConstant('Clipboard'),
            enableGroupOverflow: true,
            overflowHeader: this.localObj.getConstant('Clipboard'),
            // orientation: ItemOrientation.Row,
            groupIconCss: 'e-icons e-de-ctnr-paste',
            collections: [
                {
                    items: [
                        {
                            type: 'Button',
                            keyTip: 'X',
                            buttonSettings: {
                                content: this.localObj.getConstant('Cut'),
                                iconCss: 'e-icons e-de-ctnr-cut',
                                isToggle: false,
                                clicked: () => {
                                    if (!this.documentEditor.isReadOnly && this.documentEditor.editor) {
                                        this.documentEditor.editor.cut();
                                    }
                                }
                            },
                            id: id + CUT_ID,
                            ribbonTooltipSettings: { content: this.localObj.getConstant('Cut Tooltip') }
                        }, {
                            type: 'Button',
                            keyTip: 'C',
                            buttonSettings: {
                                content: this.localObj.getConstant('Copy'),
                                iconCss: 'e-icons e-de-ctnr-copy',
                                isToggle: false,
                                clicked: () => {
                                    if (this.documentEditor.selection) {
                                        this.documentEditor.selection.copy();
                                    }
                                }
                            },
                            id: id + COPY_ID,
                            ribbonTooltipSettings: { content: this.localObj.getConstant('Copy Tooltip') }
                        },
                        {
                            type: 'Button',
                            keyTip: 'V',
                            buttonSettings: {
                                content: this.localObj.getConstant('Local Clipboard'),
                                iconCss: 'e-icons e-de-ctnr-paste',
                                isToggle: true,
                                clicked: () => {
                                    this.container.enableLocalPaste = !this.container.enableLocalPaste;
                                }
                            },
                            id: id + LOCAL_CLIPBOARD_ID,
                            ribbonTooltipSettings: { content: this.localObj.getConstant('Toggle between the internal clipboard and system clipboard') }
                        }
                    ]
                }
            ]
        };
    }
    /**
     * Update clipboard buttons based on selection state
     * @returns {void}
     * @private
     */
    updateSelection() {
        // Get the ribbon from container
        const ribbon = this.container.ribbonModule.ribbon;
        if (!ribbon) {
            return;
        }
        const id = this.ribbonId;
        const isSelectionEmpty = this.container.documentEditor.selection.isEmpty;
        // Update Cut and Copy buttons state based on selection
        if (isSelectionEmpty) {
            ribbon.disableItem(id + CUT_ID);
            ribbon.disableItem(id + COPY_ID);
        }
        else {
            ribbon.enableItem(id + CUT_ID);
            ribbon.enableItem(id + COPY_ID);
        }
    }
}
